export default {
  content: {
    title: 'Obrigado!',
    description: 'Você realizou sua boa ação ao deixar {{firstName}} feliz',
  },
  joinCommunity: 'Por que não se juntar à comunidade?',
  downloadButton: 'Baixar SOSAFE',
  contactAgain: 'Contato {{firstName}} novamente',
};
